import {useNavigate} from "react-router-dom";
import {useCallback, useMemo} from "react";
import {NavigateOptions} from "react-router/dist/lib/context";

const useRouteHandler = () => {
    const navigate = useNavigate();

    const moveToHome = useCallback((options?: NavigateOptions) => {
        navigate("/", options);
    }, [navigate]);


    const resetRoute = useCallback( () => {
        moveToHome();

    }, [moveToHome])

    return useMemo(() => {
        return {
            moveToHome,
            resetRoute
        }
    }, [
        moveToHome,
        resetRoute
    ])
}

export default useRouteHandler;
